import { all } from "redux-saga/effects";

import TermoAceite from "./termoAceite/sagas";

export default all([TermoAceite]);
